import React, { Component } from "react";
import * as echarts from "echarts";

class SurveyPieChart extends Component {
  chartRef = React.createRef();
  chartInstance = null;

  componentDidUpdate(prevProps) {
    setTimeout(() => {
      this.initChart(this.props?.value || 0);

      // important for hidden tab
      this.chart && this.chart.resize();

    }, 200);
  }

  componentWillUnmount() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }

  initChart = (value) => {
    console.log("value--1->", value)

    if (!this.chartInstance) {
      this.chartInstance = echarts.init(this.chartRef.current);
    }

    this.chartInstance.setOption({
      series: [
        {
          type: "pie",
          radius: "100%",
          label: { show: false },
          data: [
            {
              value: value,
              itemStyle: { color: "#00BC7D" }, // main green
            },
            {
              value: 100 - value,
              itemStyle: { color: "#F3F4F6" }, // light green
            },
          ],
        },
      ],
    });
  };

  render() {
    let { value } = this.props;
    return (
      <>
        {value > 0 && <div
          ref={this.chartRef}
          style={{ width: 80, height: 80 }}
        />}
      </>
    );
  }
}

export default SurveyPieChart;